var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "price-boost" },
    [
      _vm.status === "loaded"
        ? _c(_vm.layoutType, {
            tag: "component",
            attrs: {
              teamShirts: _vm.teamShirts,
              loggedin: _vm.siteConfig.username !== "",
              betSlipUrl: _vm.addToBetslipUrl,
              event: _vm.event,
              eventDate: _vm.eventDate,
              scContent: _vm.scContent,
              priceboostSelection: _vm.priceboostSelection
            }
          })
        : _vm.status === "error"
          ? _c("div", { staticClass: "priceboost promo-container is-error" }, [
              _c("i", { staticClass: "fas fa-exclamation-circle" }),
              _vm._v(" "),
              _c("em", [_vm._v(_vm._s(_vm.userMessage))])
            ])
          : _vm._e(),
      _vm._v(" "),
      false
        ? _c("div", { staticClass: "sticky-footer hide-lg" }, [
            _c(
              "a",
              {
                staticClass: "button button--primary",
                attrs: {
                  href: _vm.scContent.FieldValues.Parameters["link_cta"]
                }
              },
              [_vm._v(_vm._s(_vm.scContent.FieldValues.Parameters["copy_cta"]))]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e92f5ec", { render: render, staticRenderFns: staticRenderFns })
  }
}